import { ModelPropertiesMapper as DefaultModelPropertiesMapper } from 'jsona'
import { JsonaModel, JsonaAttributes } from './types'

const RELATIONSHIP_NAMES_PROP = 'relationshipNames'

export class ModelPropertiesMapper extends DefaultModelPropertiesMapper {
  getType(model: JsonaModel): string {
    if (!model._type) {
      throw new Error('Provided model missing type.')
    }

    return model._type
  }

  getAttributes(model: JsonaModel) {
    const exceptProps = ['id', '_type', 'links', 'meta', RELATIONSHIP_NAMES_PROP]

    if (Array.isArray(model[RELATIONSHIP_NAMES_PROP])) {
      exceptProps.push(...model[RELATIONSHIP_NAMES_PROP])
    } else if (model[RELATIONSHIP_NAMES_PROP]) {
      // eslint-disable-next-line no-console
      console.warn(
        `Can't getAttributes correctly, '${RELATIONSHIP_NAMES_PROP}' property of ${model.type}-${model.id} model
        isn't array of relationship names`,
        model[RELATIONSHIP_NAMES_PROP]
      )
    }

    const attributes: JsonaAttributes = {}
    Object.keys(model).forEach((attrName) => {
      if (!exceptProps.includes(attrName)) {
        attributes[attrName] = model[attrName]
      }
    })

    return attributes
  }

  getMeta(model: JsonaModel) {
    return model.meta
  }

  getLinks(model: JsonaModel) {
    return model.links
  }
}
